var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useContext, useState } from 'react';
import '../components/clearstep/proto/results_pb';
import { PartnerCustomizationContext } from '../components/tailwind_clearstep/Partners/symptom_check/PartnerCustomizations';
var defaultContext = {
    setVisitTypeForCareType: function () { },
    getVisitTypeForCareType: function () { return undefined; },
};
export var CareTypeVisitTypeContext = createContext(defaultContext);
export var CareTypeVisitTypeProvider = function (_a) {
    var children = _a.children;
    var _b = useState({}), careTypeSelectedVisitType = _b[0], setCareTypeSelectedVisitType = _b[1];
    var setVisitTypeForCareType = function (careType, visitTypeId) {
        setCareTypeSelectedVisitType(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[careType] = visitTypeId, _a)));
        });
    };
    var getVisitTypeForCareType = function (careType) {
        return careTypeSelectedVisitType[careType];
    };
    var value = React.useMemo(function () { return ({
        setVisitTypeForCareType: setVisitTypeForCareType,
        getVisitTypeForCareType: getVisitTypeForCareType,
    }); }, [careTypeSelectedVisitType]);
    return (React.createElement(CareTypeVisitTypeContext.Provider, { value: value }, children));
};
export var useCareTypeVisitType = function () {
    var context = useContext(CareTypeVisitTypeContext);
    if (!context) {
        throw new Error('useCareTypeVisitType must be used within a CareTypeVisitTypeProvider');
    }
    return context;
};
export var CareTypeVisitTypeProviderWrapper = function (props) {
    var partnerCustomizations = useContext(PartnerCustomizationContext);
    var careOptions = props.careOptions, children = props.children;
    // Check if any care option supports visit type filters (which includes care type visit type functionality)
    var shouldEnable = careOptions.some(function (careOption) {
        return partnerCustomizations.enableVisitTypeFilters(careOption);
    });
    if (!shouldEnable) {
        return (React.createElement(CareTypeVisitTypeContext.Provider, { value: defaultContext }, children));
    }
    return React.createElement(CareTypeVisitTypeProvider, null, children);
};
